import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  FileText,
  Shield,
  CreditCard,
  BarChart3,
  Music,
  Sparkles,
  Megaphone,
  Banknote,
  Image as ImageIcon,
  Coins,
  Wand2,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItem {
  href: string;
  label: string;
  icon: LucideIcon;
}

const navItems: NavItem[] = [
  { href: '/', label: 'Dashboard', icon: LayoutDashboard },
  { href: '/users', label: 'Users', icon: Users },
  { href: '/proposals', label: 'Proposals', icon: FileText },
  { href: '/templates', label: 'Templates', icon: Sparkles },
  { href: '/transitions', label: 'Page Transitions', icon: Wand2 },
  { href: '/moderation', label: 'Moderation', icon: Shield },
  { href: '/payments', label: 'Payments', icon: CreditCard },
  { href: '/finance', label: 'Finance', icon: Banknote },
  { href: '/analytics', label: 'Analytics', icon: BarChart3 },
  { href: '/ads', label: 'Ads', icon: Megaphone },
  { href: '/audio', label: 'Audio', icon: Music },
  { href: '/media', label: 'Media', icon: ImageIcon },
  { href: '/ai-model-pricing', label: 'AI Model & Pricing', icon: Coins },
];

export function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img
          src="/merryflix_logo.png"
          alt="Merryflix"
          className="h-7 w-auto object-contain drop-shadow-[0_0_10px_rgba(255,51,119,0.5)]"
        />
        <div className="leading-tight">
          <div className="text-[13px] font-semibold tracking-tight text-white">
            MerryFlix
          </div>
          <div className="text-[10px] font-medium uppercase tracking-[0.14em] text-[var(--color-quaternary-label)]">
            Admin
          </div>
        </div>
      </div>

      <nav className="flex-1 py-3" aria-label="Primary">
        <div className="sidebar-section">Workspace</div>
        {navItems.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            end={item.href === '/'}
            className={({ isActive }) =>
              cn('sidebar-item', isActive && 'is-active')
            }
          >
            {({ isActive }) => (
              <>
                <item.icon className="sidebar-icon" />
                <span className="flex-1 truncate">{item.label}</span>
                {isActive ? (
                  <span className="h-1.5 w-1.5 rounded-full bg-white shadow-[0_0_6px_rgba(255,255,255,0.8)]" />
                ) : null}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div>v2.0 · MerryFlix Admin</div>
      </div>
    </aside>
  );
}